import React from "react";
import CaseRelatedActions from "../components/Case/CaseRelatedActions/CaseRelatedActions";
import { Route, Routes } from "react-router-dom";
import CallcenterCasePage from "../components/_Pages/CallCenterPages/CallcenterCasePage/CallcenterCasePage";
import { CallProvider } from "../provider/CallProvider";
import { DrawerProvider } from "../provider/DrawerProvider";
import CaseRouteProvider from "../provider/CaseRouteProvider";

const CallcenterCaseRoutes = () => {
  return (
    <CaseRouteProvider>
      <DrawerProvider>
        <CallProvider>
          <CaseRelatedActions />

          <Routes>
            <Route path={"/"} element={<CallcenterCasePage />} />
          </Routes>
        </CallProvider>
      </DrawerProvider>
    </CaseRouteProvider>
  );
};

export default CallcenterCaseRoutes;
